/** Pedido ONE tal como llega en `one_orders` (GET shopper/orders/open_orders) */
export interface OneOrder {
  idp: number;
  id_public: string;
  tit?: string;
  url?: string;
  url_host?: string;
  img_path?: string;
  can?: number | string;
  obs?: string;
  /** "nuevo" en ONE (pendiente en `one_orders`) */
  condicion?: string | null;
  /** "sellado" en ONE (pendiente en `one_orders`) */
  empaque?: string | null;
  estado: string;
  feccre?: string;
  /** Precio + impuestos (`real_price × can`), en USD, guardado al pagar */
  pre?: number | string | null;
  /** Fee del viajero (`traveler_fee × can`), en USD, guardado al pagar */
  com?: number | string | null;
  /** Desglose del total pagado, calculado por el backend; null si no hay snapshot del pago */
  paid_breakdown?: OneTotals | null;
  /** 1 si el comprador eligió envío nacional al pagar; null si no */
  flag_envio?: number | null;
  product_one?: {
    deal_time_days?: number | null;
    deal_time_custom_message?: string | null;
  } | null;
}

/** Desglose de lo que pagó el comprador, en USD */
export interface OneTotals {
  price: number;
  traveler: number;
  guvery: number;
  discount: number;
  total: number;
}

/** Desglose del total pagado; null si el backend no lo envía */
export const oneTotals = (order: OneOrder): OneTotals | null => order.paid_breakdown ?? null;

/** Mensaje de asignación: el del producto, o el promedio de días (2 por defecto) */
export const assigningText = (order: Pick<OneOrder, 'product_one'>) => {
  const productOne = order.product_one;
  if (productOne?.deal_time_custom_message) return productOne.deal_time_custom_message;
  const days = productOne?.deal_time_days || 2;
  return `Asignando tu pedido al mejor viajero disponible (${days} días promedio).`;
};
